// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"e2c86c51","498":"b4f2221e","513":"c36863ee","703":"1b3d39c8","761":"7aa44085","787":"4340d703"}[chunkId] + ".chunk.js";
};